import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, PhoneCall } from "lucide-react";
import HeroWheel from "./HeroWheel";

export default function FinalCta() {
  return (
    <section className="relative overflow-hidden bg-[#030B18] py-24 sm:py-32" data-testid="final-cta">
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-60">
        <HeroWheel compact />
      </div>
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-[#030B18] via-transparent to-[#030B18]" />
      <div className="relative mx-auto max-w-4xl px-5 text-center">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}>
          <h2 className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-5xl">
            READY TO <span className="text-saffron-green">SHIP SMARTER?</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-slate-300 sm:text-base">
            Connect your business to ShipAny and manage your shipping from one powerful platform.
          </p>
          <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link to="/signup" data-testid="final-cta-start-free-btn"
              className="group flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#FF9933] to-[#FF8000] px-9 py-4 font-display text-sm font-bold text-[#071B3A] transition-all hover:shadow-[0_12px_40px_rgba(255,153,51,0.45)] sm:w-auto">
              START SHIPPING FREE <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
            <Link to="/contact" data-testid="final-cta-sales-btn"
              className="flex w-full items-center justify-center gap-2 rounded-xl border border-white/25 bg-white/5 px-9 py-4 font-display text-sm font-bold text-white backdrop-blur transition-colors hover:bg-white/10 sm:w-auto">
              <PhoneCall className="h-4 w-4" /> TALK TO SALES
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
